import { Control, FieldErrors, UseFormGetValues, UseFormSetValue } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FileUploadForm, Table } from 'coreOld/components';
import { TableNames } from 'coreOld/constants';
import { IFile } from 'coreOld/types';
import { IJob } from 'jobsOld/types';
import { IRequestJobs } from 'support/types';

import { columns } from './columns';

interface IProps {
  requestJobs: IJob[];
  control: Control<IRequestJobs, object>;
  getValues: UseFormGetValues<IRequestJobs>;
  setValue: UseFormSetValue<IRequestJobs>;
  errors?: FieldErrors<IRequestJobs>;
  selectedJob?: IJob | null;
  uploadModalOpen?: boolean;
  onUploadModalOpen?: (job: IJob) => void;
  onUploadModalClose?: () => void;
  onSubmitUploadFile?: (files: IFile[]) => void;
}

const DisciplineJobTableView = ({
  requestJobs,
  control,
  getValues,
  setValue,
  errors,
  selectedJob,
  uploadModalOpen,
  onUploadModalOpen,
  onUploadModalClose,
  onSubmitUploadFile,
}: IProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Table
        columns={columns(control, getValues, setValue, errors, onUploadModalOpen)}
        data={requestJobs}
        name={TableNames.SUPPORT_REQUEST_DISCIPLINE_JOB_LIST}
        noItemsFoundText={t('messageNoJobsAddedToSupportRequest')}
        bodyHeightAuto
        borderBottom
        borderTop
      />

      <FileUploadForm
        isOpen={uploadModalOpen}
        onClose={onUploadModalClose}
        title={t('labelJobAttachments')}
        defaultValues={selectedJob?.attachments || []}
        onSubmit={onSubmitUploadFile}
      />
    </>
  );
};

export default DisciplineJobTableView;
